var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home"},[_c('Banner'),_c('AboutSection'),_c('NumbersSection'),_c('ServiceSection'),_c('TextEmphasis',{attrs:{"imgBg":'bg-frase',"text":'Grandes coisas nos negócios nunca são feitas por uma pessoa. <span>Elas são feitas por um time de pessoas.</span>'}}),_c('ComunicationSection'),_c('ProductSection'),_c('CaseSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }